import { useMemo } from 'react';
import type { NavigateProps } from 'react-router-dom';
import { Navigate, useLocation, parsePath } from 'react-router-dom';

export type RedirectProps<S = any> = Omit<NavigateProps, 'state'> & {
  /** no merge */
  keepSearch?: boolean;
  keepState?: boolean;
  state?: S;
};

function Redirect<S = any>(props: RedirectProps<S>) {
  const { to, keepSearch, keepState, state, ...rest } = props;
  const location = useLocation();

  const navTo = useMemo<NavigateProps['to']>(() => {
    if (keepSearch && location?.search) {
      const _path = typeof to === 'string' ? parsePath(to) : to;

      return {
        pathname: _path.pathname,
        hash: _path.hash,
        search: location.search,
      };
    }

    return to;
  }, [keepSearch, location?.search, to]);

  return <Navigate to={navTo} state={keepState ? location.state : state} {...rest} />;
}

export default Redirect;
